// @ts-strict-ignore
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Sheet } from '@node-space/ui-components'
import { ConfirmCustomerData } from '../helpers/types'
import { AddCustomerConfirmDetails } from './AddCustomerConfirmDetails'
import { AddCustomerForm } from './AddCustomerForm'

export interface AddCustomerProps {
  isOpen: boolean
  onClose: () => void
  onCustomerAdded: () => void
}
interface FieldErrors {
  [field: string]: string[]
  requestBody?: string[]
}

export const AddCustomer = ({ isOpen, onClose, onCustomerAdded }: AddCustomerProps) => {
  const { t } = useTranslation()
  const [isConfirmDetailsView, setIsConfirmDetailsView] = useState(false)
  const [customerData, setCustomerData] = useState<ConfirmCustomerData>()

  const [fieldErrors, setFieldErrors] = useState<FieldErrors | null>()
  const onConfirmDetails = (updatedCustomerData: ConfirmCustomerData) => {
    setCustomerData(updatedCustomerData)
    setIsConfirmDetailsView(true)
  }

  const onBack = () => {
    isConfirmDetailsView ? setIsConfirmDetailsView(false) : onClose()
  }

  const resetAddCustomer = () => {
    setCustomerData(null)
    setIsConfirmDetailsView(false)
    setFieldErrors(null)

    onClose()
  }

  const onCancel = () => {
    resetAddCustomer()
    setFieldErrors(null)
  }

  const onSuccess = () => {
    resetAddCustomer()
    onCustomerAdded()
    setFieldErrors(null)
  }

  const onError = (errors?: FieldErrors) => {
    setFieldErrors(errors)
    onBack()
  }

  return (
    <Sheet
      isOpen={isOpen}
      onClose={() => {
        onClose()
      }}
      header={t(isConfirmDetailsView ? 'customers.confirmDetails' : 'customers.newCustomer')}
      onBack={onBack}
    >
      <Box width="full" paddingY={24}>
        {isConfirmDetailsView ? (
          <AddCustomerConfirmDetails
            customerData={customerData}
            onCancel={onCancel}
            onSuccess={onSuccess}
            onError={onError}
          />
        ) : (
          <AddCustomerForm
            defaultValues={customerData}
            onConfirm={onConfirmDetails}
            onCancel={onCancel}
            fieldErrors={fieldErrors}
            setFieldErrors={setFieldErrors}
          />
        )}
      </Box>
    </Sheet>
  )
}
